import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoadSecondary } from '../../../store/state/monitoring/transport/models';
import { DateType, DeviationType, LoadStatus } from '../../../store';
import { IconNames } from '../../../common';

@Component({
  selector: 'ui-load-info-bar-header-dates',
  templateUrl: './load-info-bar-header-dates.component.html',
  styleUrls: ['./load-info-bar-header-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadInfoBarHeaderDatesComponent {
  @Input() load: LoadSecondary;
  @Input() loadStatus: LoadStatus;
  @Input() hasLabel: boolean;
  @Input() hasSpeedUpInfo: boolean;

  deviationType = DeviationType;
  dateType = DateType;
  iconNameList = IconNames;
}
